<template>
  <v-menu
    v-model="contextMenuModel"
    :target="[positionX, positionY]"
    :close-on-content-click="false"
    :persistent="false"
    location="bottom"
    absolute
    z-index="2001"
    style="z-index: 2001 !important;"
  >
    <v-list v-if="node" style="overflow-y:auto;" data-cy="nodeSideMenu-treeItemContext-list">

      <v-list-item
        v-if="$canControlNodeAndPod() && !isCurrentNodeTenant"
        @click="openDeleteNodeDialog"
        data-cy="nodeSideMenu-treeItemContext-deleteNode"
        prepend-icon="mdi-trash-can-outline"
      >
        <v-list-item-title>
          {{ $t('menus.tools.deleteNode') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="node.archived && $canControlNodeAndPod() && $canArchiveNodeAndPod()"
        @click="openUnarchiveDialog"
        data-cy="nodeSideMenu-treeItemContext-unarchiveSelected"
        prepend-icon="mdi-archive-arrow-up-outline"
      >
        <v-list-item-title>
          {{ $t('menus.tools.unarchiveSelected') }}
        </v-list-item-title>
      </v-list-item>

    </v-list>
  </v-menu>

  <!-- Standalone dialogs -->
  <DeleteNodeDialog
    v-if="$canControlNodeAndPod() && !isCurrentNodeTenant"
    :node="node"
    v-model="showDeleteNodeDialog"
  />

  <ArchiveSelectedDialog
    v-if="node.archived && $canControlNodeAndPod() && $canArchiveNodeAndPod()"
    :action="'unarchive'"
    :nodes="Array(node)"
    :pods="Array()"
    v-model="showUnarchiveDialog"
  />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useNodeStore } from '@/stores/NodeStore.js';
import { useCommonStore } from '@/stores/CommonStore.js';
import DeleteNodeDialog from '../../../../layouts2/mainLayout/components/nodeSidemenu/components/dialogs/DeleteNodeDialog.vue';
import ArchiveSelectedDialog from '../dialogs/ArchiveSelectedDialog.vue';

export default {
  emits: ['update:modelValue'],
  name: "ArchivedNodeContextMenu",

  components: {
    DeleteNodeDialog,
    ArchiveSelectedDialog,
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
    node: {
      type: Object,
      // required: true,
    },
  },

  data() {
    return {
      showDeleteNodeDialog: false,
      showUnarchiveDialog: false,
    };
  },

  watch: {
    nodeFromState() {
      if (this.nodeFromState && this.nodeFromState.archived !== this.archiveStatus.ARCHIVED) {
        this.contextMenuModel = false;
      }
    },
  },

  methods: {
    openDeleteNodeDialog() {
      this.contextMenuModel = false;
      this.$nextTick(() => {
        this.showDeleteNodeDialog = true;
      });
    },
    openUnarchiveDialog() {
      this.contextMenuModel = false;
      this.$nextTick(() => {
        this.showUnarchiveDialog = true;
      });
    },
    selectAllFilesAndFolders() {
      if (this.currentNodeId) {
        const podStore = usePodStore();
        podStore.selectFilesInFolder({ nodeId: this.currentNodeId });

        const nodeStore = useNodeStore();
        nodeStore._selectSubfolders({ nodeId: this.currentNodeId });
      }
    },
    deselectAllFilesAndFolders() {
      const nodeStore = useNodeStore();
      nodeStore.deselectAllNodes();

      const podStore = usePodStore();
      podStore.deselectAllPods();
    },
  },

  computed: {
    contextMenuModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

    rootFolderId() {
      const commonStore = useCommonStore();
      return commonStore.rootFolderId;
    },
    nodeTypes() {
      const commonStore = useCommonStore();
      return commonStore.nodeTypes;
    },
    archiveStatus() {
      const commonStore = useCommonStore();
      return commonStore.archiveStatus;
    },
    nodeFromState() {
      if (!this.node || !this.node.id) {
        return null;
      }

      // This is the node from the state manager.
      // The node from the props is from event and does not have watch events.
      const nodeStore = useNodeStore();
      return nodeStore.getNodeById(this.node.id);
    },
    isCurrentNodeTenant() {
      // return this.node.type === this.nodeTypes.TENANT;
      return this.node.parentid == this.rootFolderId && this.node.type === this.nodeTypes.TENANT;
    },
    currentNodeId() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNodeId;
    },
    hasSelectedItems() {
      const nodeStore = useNodeStore();
      const podStore = usePodStore();

      return nodeStore.hasSelectedNodes || podStore.hasSelectedPods;
    },
  }
};
</script>

<style>
</style>
